import React from 'react';
import { MessageCircle } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function FloatingWhatsApp() {
  return (
    <Link
      to="/dosage"
      aria-label="Read today's Dosage"
      data-testid="floating-dosage-btn"
      className="fixed bottom-5 right-5 z-40 group flex items-center gap-3 h-14 pl-4 pr-5 rounded-full bg-[#25D366] hover:bg-[#20BA5A] text-white shadow-[0_10px_30px_-8px_rgba(37,211,102,0.55)] transition-all hover:scale-105"
    >
      <span className="relative flex items-center justify-center">
        <span className="absolute inline-flex h-full w-full rounded-full bg-white/40 animate-ping" />
        <MessageCircle className="relative h-6 w-6 fill-white text-[#25D366]" strokeWidth={1.5} />
      </span>
      <span className="hidden sm:inline font-semibold tracking-wide text-sm">Today&rsquo;s Dosage</span>
    </Link>
  );
}
